module.exports = __webpack_public_path__ + "img/monkey-white.4b6c0742.png";